import React, { useEffect, useState } from "react";
import styled from "styled-components";
import dayjs from "dayjs";
import { getLocale } from "react-i18nify";
import { CSVLink } from "react-csv";

import * as MatStyled from "@mui/material/styles";
import Box from "@mui/material/Box";
import TextField from "@mui/material/TextField";
import SearchIcon from "@mui/icons-material/Search";
import IconButton from "@mui/material/IconButton";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";

// import InputAdornment from "@mui/material/InputAdornment";
// import { makeStyles } from '@material-ui/core'

import { DataGrid } from "@mui/x-data-grid";
import { GridActionsCellItem } from "@mui/x-data-grid";

import {
  getAllProductType,
  deleteMasterData,
  getMasterDataCsv,
  importMasterDataCsv,
} from "src/api/master-data";

import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import AddIcon from "@mui/icons-material/Add";
import FileUploadIcon from "@mui/icons-material/FileUpload";
import FileDownloadIcon from "@mui/icons-material/FileDownload";

import { checkNotEmpty } from "src/common";
import { useAuth } from "src/hooks/useAuth";
import { useDialog } from "src/context/DialogContext";

import Button from "src/components/core/Button";
import Loading from "src/components/ui/Loading";
import UploadFile from "src/components/upload/dropzone/UploadFile";
import AddTypeDialog from "src/modules/product-type/modal/AddTypeDialog";
import { Grey, Primary } from "src/styles/color";

const DivMuiName = styled.div`
  width: 100%;
  height: auto;
  padding: 32px;
  border-radius: 32px;
  background-color: #ffffff;
  box-shadow: 0px 4px 20px rgba(0, 0, 0, 0.1);
  // display: flex;
  justify-content: center;
  align-items: center;
`;

const DivMuiInside = styled.div`
  width: 100%;
  margin-bottom: 20px;
  /* display: flex;
  justify-content: space-between; */
`;

const WrapperText = styled.div`
  // margin-bottom: 32px;
  width: 60%;
  position: relative;
  display: flex;
  justify-content: center;
  .TextField-without-border-radius fieldset {
    border-radius: 16px;
  }
`;

const WrapperDataGrid = styled.div`
  height: 600px;
  width: 100%;
  .MuiDataGrid-root {
    border: 1px solid #ffffff;
  }
  .MuiDataGrid-columnHeaders {
    background-color: #f5f5f5;
  }
  .MuiDataGrid-root .MuiDataGrid-columnSeparator--sideRight {
    color: #f5f5f5;
  }
  .MuiDataGrid-root .MuiDataGrid-columnHeader:focus-within {
    // outline: solid #f5f5f5 1px;
    outline: none;
  }
  .MuiDataGrid-root .MuiDataGrid-cell:focus {
    outline: none;
    border-bottom: solid #f5f5f5 1px 0 1px 0;
  }
  .MuiDataGrid-root .MuiDataGrid-row.Mui-selected {
    background-color: #ffffff;
  }
`;

const ImageNoData = styled.image`
  width: 120px;
  height: 120px;
  background-image: url("https://xsurface-images.s3.ap-southeast-1.amazonaws.com/no+data.svg");
  background-repeat: no-repeat;
  background-size: 100%;
`;

const ImageNotFound = styled.image`
  width: 120px;
  height: 120px;
  background-image: url("https://xsurface-images.s3.ap-southeast-1.amazonaws.com/not+found.svg");
  background-repeat: no-repeat;
  background-size: 100%;
`;

const TextNoData = styled.pre`
  font-style: normal;
  font-weight: 500;
  font-size: 20px;
`;

const drawerWidth = 260;

const Main = MatStyled.styled("main", {
  shouldForwardProp: (prop) => prop !== "open",
})(({ theme, open }) => ({
  position: "relative",
  flexGrow: 1,
  padding: theme.spacing(3),
  transition: theme.transitions.create("margin", {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  marginLeft: `-${drawerWidth}px`,
  height: "100vh",
  overflow: "hidden",
  overflowY: "scroll",
  ...(open && {
    transition: theme.transitions.create("margin", {
      easing: theme.transitions.easing.easeOut,
      duration: theme.transitions.duration.enteringScreen,
    }),
    marginLeft: 0,
    position: "relative",
  }),
}));

const DrawerHeader = MatStyled.styled("div")(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  padding: theme.spacing(0, 1),
  ...theme.mixins.toolbar,
  justifyContent: "flex-end",
  height: "75px",
}));

function ProductTypeList({ open }) {
  const { user } = useAuth();
  const { openDialog, closeDialog } = useDialog();

  const [productTypeList, setProductTypeList] = useState([]);
  const [typeDataCsv, setTypeDataCsv] = useState([]);
  const [isFetchingDataCsv, setIsFetchingDataCsv] = useState(false);

  const [isDataLoading, setIsDataLoading] = useState(false);
  const [dataSearch, setDataSearch] = useState({
    keywords: "",
    page: 0,
    // page_size: 10,
  });

  const [isLoading, setIsLoading] = useState(false);

  const columns = [
    {
      field: "type_name", // !
      headerName: "ประเภทสินค้า",
      flex: 1.5,
      // width: 200,
      headerAlign: "left",
      editable: false,
      sortable: false,
      disableColumnMenu: true,
      renderCell: (params) => {
        return (
          <Box
            sx={{
              width: "100%",
              height: "100%",
              margin: "8px",
              display: "flex",
              justifyContent: "flex-start",
              alignItems: "center",
              outline: "none",
              overflow: "hidden",
              textOverflow: "ellipsis",
            }}
          >
            <div style={{ margin: "8px", width: "100%", minHeight: "50px" }}>
              <div
                className="MuiDataGrid-cellContent"
                style={{
                  fontSize: "0.875rem",
                  fontWeight: 400,
                  lineHeight: 1.5,
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                }}
              >
                {params.row?.type_en ? params.row?.type_en : "-"}
              </div>
              <div
                className="MuiDataGrid-cellContent"
                style={{
                  fontSize: "0.875rem",
                  fontWeight: 400,
                  lineHeight: 1.5,
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                }}
              >
                {params.row?.type_th ? params.row?.type_th : "-"}
              </div>
            </div>
          </Box>
        );
      },
    },
    {
      field: "category", // !
      headerName: "หมวดหมู่",
      flex: 1,
      headerAlign: "center",
      align: "center",
      editable: false,
      sortable: false,
      disableColumnMenu: true,
      renderCell: (params) => {
        return (
          <div
            // className="MuiDataGrid-cellContent"
            style={{
              fontSize: "0.875rem",
              fontWeight: 400,
              lineHeight: 1.5,
              maxWidth: 210,
              // overflowWrap: "break-word",
              overflow: "hidden",
              textOverflow: "ellipsis",
            }}
          >
            {checkNotEmpty(params.row?.category)
              ? params.row?.category?.cate_th
              : "-"}
          </div>
        );
      },
    },
    {
      field: "product_count", // !
      headerName: "จำนวนสินค้า",
      flex: 1,
      headerAlign: "center",
      align: "center",
      editable: false,
      sortable: false,
      disableColumnMenu: true,
      renderCell: (params) => {
        return (
          <div
            className="MuiDataGrid-cellContent"
            style={{
              fontSize: "0.875rem",
              fontWeight: 400,
              lineHeight: 1.5,
              overflow: "hidden",
              textOverflow: "ellipsis",
            }}
          >
            {params.row?.product_count}
          </div>
        );
      },
    },
    {
      field: "action",
      type: "actions",
      flex: 1,
      headerAlign: "center",
      align: "center",
      editable: false,
      sortable: false,
      disableColumnMenu: true,
      getActions: (params) => [
        <GridActionsCellItem
          icon={<EditIcon />}
          label="Edit"
          onClick={() =>
            openDialog({
              type: "custom",
              customDialog: (
                <AddTypeDialog
                  typeId={params?.row?._id}
                  onClose={() => closeDialog()}
                  onSuccess={() => {
                    fetchAllProductType();
                    closeDialog();
                  }}
                  setIsLoading={setIsLoading}
                />
              ),
            })
          }
          showInMenu
        />,
        <GridActionsCellItem
          icon={<DeleteIcon />}
          label="Delete"
          onClick={() => {
            openDialog({
              type: "confirm",
              title:
                getLocale() === "th"
                  ? `คุณต้องการลบประเภทสินค้าใช่หรือไม่\nหากกดยืนยันแล้วจะไม่สามารถแก้ไขได้อีก`
                  : `คุณต้องการลบประเภทสินค้าใช่หรือไม่\nหากกดยืนยันแล้วจะไม่สามารถแก้ไขได้อีก`,
              onConfirm: () => {
                deleteProductType(params.row?._id);
              },
              maxWidth: 342,
            });
          }}
          showInMenu
        />,
      ],
    },
  ];

  function NoRowsOverlay() {
    return (
      <Stack height="100%" alignItems="center" justifyContent="center">
        <ImageNoData></ImageNoData>
        <TextNoData>No Data</TextNoData>
      </Stack>
    );
  }

  function NoResultsOverlay() {
    return (
      <Stack height="100%" alignItems="center" justifyContent="center">
        <ImageNotFound></ImageNotFound>
        <TextNoData>Not Found</TextNoData>
      </Stack>
    );
  }

  const fetchAllProductType = async () => {
    try {
      setIsDataLoading(true);

      const data = await getAllProductType({ ...dataSearch });
      // console.log("----data----", data);

      setProductTypeList(data);
    } catch (error) {
      console.error("Error fetching product types:", error);
    } finally {
      setIsDataLoading(false);
    }
  };

  const handlePageChange = (newPage) => {
    // We have the cursor, we can allow the page transition.
    setDataSearch({ ...dataSearch, page: newPage });
  };

  const onSearchButton = () => {
    setDataSearch({ ...dataSearch, page: 0 });

    fetchAllProductType();
  };

  const deleteProductType = async (id) => {
    console.log("id", id);
    if (id === null || id === undefined) return;

    try {
      setIsLoading(true);

      const res = await deleteMasterData(id, { type: "product_type" });
      if (res && res.success) {
        handlePageChange(0);
        fetchAllProductType();
      }
    } catch (err) {
      console.error("delete product type err:", err);
    } finally {
      setIsLoading(false);
    }
  };

  /**
   *
   * @param {file} fileCallBlack - csv file
   */
  const handleImportFile = async (fileCallBlack) => {
    try {
      setIsLoading(true);

      const res = await importMasterDataCsv({
        type: "product_type",
        file: fileCallBlack,
      });

      if (res && res.success) {
        const data = await getAllProductType({ ...dataSearch });
        setProductTypeList(data);
      }
    } catch (error) {
      console.error("Error importing CSV file:", error);
    } finally {
      setIsLoading(false);
    }
  };

  // fetch product stock data
  const fetchTypeDataCSV = async () => {
    try {
      setIsFetchingDataCsv(true);

      const pdCsvfetch = await getMasterDataCsv({ type: "product_type" });
      const pdCsvList = JSON.parse(JSON.stringify(pdCsvfetch));

      if (pdCsvList.length > 0) {
        const format = pdCsvList.map((el, index) => {
          const {
            _id,
            type_en,
            type_th,
            category_th,
            keywords,
            brand,
            meta_desc,
            meta_keywords,
            meta_title,
            status,
          } = el;

          const group_header = {
            ลำดับที่: index + 1,
            id: _id,
            หมวดหมู่: category_th,
            "ชื่อประเภทสินค้า (อังกฤษ)": type_en,
            "ชื่อประเภทสินค้า (ไทย)": type_th,
            คำค้นหาในเว็บ: keywords,
            แบรนด์ที่เกี่ยวข้อง: brand,
            "Meta tag Title": meta_title,
            "Meta tag Description": meta_desc,
            "Meta tag Keywords": meta_keywords,
            สถานะ: status,
          };

          return group_header;
        });

        setTypeDataCsv(format);
      } else {
        setTypeDataCsv([]);
      }
    } catch (error) {
      console.log({ error });
    } finally {
      setIsFetchingDataCsv(false);
    }
  };

  useEffect(() => {
    if (user.role_id === 1) {
      fetchAllProductType();
      fetchTypeDataCSV();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const exportCsvCondition = !isFetchingDataCsv && typeDataCsv.length > 0;

  return (
    <>
      <Main open={open}>
        <DrawerHeader />
        <DivMuiName>
          <DivMuiInside>
            <Box
              sx={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                gap: 2,
                mb: 1,
                mr: 2,
              }}
            >
              <WrapperText>
                <TextField
                  id="search-input"
                  placeholder="ค้นหา"
                  className="TextField-without-border-radius"
                  sx={{
                    m: 1,
                    width: "100%",
                    borderRadius: "16px",
                  }}
                  InputProps={{
                    endAdornment: (
                      <IconButton
                        id="button-search-sample"
                        sx={{ padding: 0 }}
                        onClick={() => {
                          onSearchButton();
                        }}
                      >
                        <SearchIcon
                          sx={{ color: "#e04132", cursor: "pointer" }}
                        />
                      </IconButton>
                    ),
                  }}
                  onChange={(e) => {
                    setDataSearch({ ...dataSearch, keywords: e.target.value });
                  }}
                  onKeyUp={(e) =>
                    e.code === "Enter" ? onSearchButton() : null
                  }
                />
              </WrapperText>

              <Button
                variant="contained"
                startIcon={<AddIcon />}
                size="large"
                onClick={() =>
                  openDialog({
                    type: "custom",
                    customDialog: (
                      <AddTypeDialog
                        onClose={() => closeDialog()}
                        onSuccess={() => {
                          fetchAllProductType();
                          closeDialog();
                        }}
                        setIsLoading={setIsLoading}
                      />
                    ),
                  })
                }
              >
                เพิ่มประเภทสินค้า
              </Button>
            </Box>

            <Box
              sx={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                ml: 2,
              }}
            >
              <Typography component="span">
                ประเภททั้งหมด:{" "}
                <Typography
                  component="span"
                  sx={{
                    color: "#E13B30",
                  }}
                >
                  {productTypeList.length}
                </Typography>
              </Typography>
              {/* import / export data */}
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  gap: 1,
                }}
              >
                <Button variant="text" disabled={!exportCsvCondition}>
                  <CSVLink
                    style={{
                      display: "flex",
                      fontWeight: "500",
                      fontSize: "15px",
                      justifyContent: "end ",
                      alignItems: "center",
                      gap: "8px",
                      fontStyle: "normal",
                      color: exportCsvCondition ? `${Primary}` : `${Grey}`,
                      cursor: exportCsvCondition ? "pointer" : "no-drop",
                      pointerEvents: exportCsvCondition ? "auto" : "none",
                    }}
                    data={typeDataCsv}
                    filename={`product-type-${dayjs(new Date()).format("DD-MM-YYYY")}.csv`}
                    onClick={(event, done) => {
                      if (!exportCsvCondition) {
                        return false;
                      }
                    }}
                  >
                    <FileUploadIcon /> Export data File
                  </CSVLink>
                </Button>

                <UploadFile
                  callBackFile={(fileCallBlack) =>
                    handleImportFile(fileCallBlack)
                  }
                  closeAlert={false}
                  acceptFileType={[".csv", ".xlsx"]}
                  onClick={() => {
                    // if (!stockImportCsvCondition) {
                    //   return false;
                    // }
                    return false;
                  }}
                >
                  <Button
                    variant="text"
                    color="secondary"
                    startIcon={<FileDownloadIcon />}
                    // disabled={!stockImportCsvCondition}
                  >
                    Upload data file (.csv/.xlsx)
                  </Button>
                </UploadFile>
              </Box>
            </Box>

            {isFetchingDataCsv ? (
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "end",
                  mr: 2,
                  my: 2,
                }}
              >
                <Typography
                  sx={{
                    color: Primary,
                    fontSize: "12px",
                  }}
                >
                  กำลังดาวน์โหลดไฟล์...
                </Typography>
              </Box>
            ) : null}
          </DivMuiInside>

          <WrapperDataGrid>
            <DataGrid
              rows={productTypeList}
              getRowId={(row) => row._id}
              getRowHeight={() => "auto"}
              loading={isDataLoading}
              columns={columns}
              paginationMode="client"
              // rowCount={rowCount}
              page={dataSearch.page}
              onPageChange={(e) => handlePageChange(e)}
              pageSize={10}
              rowsPerPageOptions={[10]}
              pagination
              disableSelectionOnClick
              // localeText={{
              //   footerRowSelected: CustomPagination,
              // }}
              components={{
                // Footer: CustomPagination,
                NoRowsOverlay,
                NoResultsOverlay,
              }}
              componentsProps={{
                basePopper: {},
              }}
              sx={{
                "& .MuiDataGrid-actionsCell": {
                  transform: "rotate(90deg)",
                },
              }}
            />
          </WrapperDataGrid>
        </DivMuiName>
      </Main>

      {isLoading && <Loading />}
    </>
  );
}

export default ProductTypeList;
